require('./bootstrap');

// Register $ global var for jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

//JQuery autocomplete

//~ import $ from 'jquery';

//~ window.$ = window.jQuery = $;

//~ import 'jquery-ui/ui/widgets/autocomplete.js';
import 'bootstrap-star-rating/js/star-rating.js';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
window.Quill = Quill;
// import 'bootstrap-star-rating/themes/krajee-fa/theme.js';

//~ import flatpickr from "flatpickr";

//~ import { French } from "flatpickr/dist/l10n/fr.js";



//~ $('#autocomplete').autocomplete();
